import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from '@/auth/AuthContext';
import { I18nProvider } from '@/i18n/I18nProvider';
import { RtlProvider } from '@/i18n/RtlProvider';
import { NotificationProvider } from '@/components/common/NotificationProvider';
import { WorkspaceProvider } from '@/stores/WorkspaceStore';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import { queryClient } from '@/lib/queryClient';
import theme from '@/theme/theme';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <NotificationProvider>
            <BrowserRouter>
              <AuthProvider>
                <I18nProvider>
                  <RtlProvider>
                    {/* Inside auth, because a workspace only means something once somebody is signed
                        in — and outside the router's screens, because the header and the rail both
                        read it. It scopes nothing and grants nothing; see WorkspaceStore. */}
                    <WorkspaceProvider>
                      <App />
                    </WorkspaceProvider>
                  </RtlProvider>
                </I18nProvider>
              </AuthProvider>
            </BrowserRouter>
          </NotificationProvider>
        </QueryClientProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </React.StrictMode>,
);
